import { lazyWithRetry } from 'src/react-app/utilits/lazy-with-retry'

export const HistoryTableAsync = lazyWithRetry(() => import('./history-table'))
